import styled from '@emotion/styled/macro';
import themeGet from '@styled-system/theme-get';
import { Avatar } from './Avatar';

export const AvatarGroup = styled.div(props => ({
  [`${Avatar} + ${Avatar}`]: {
    marginLeft: -themeGet('space.1')(props)
  }
}));
